import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/user.service';
import * as fileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { DxButtonModule } from 'devextreme-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-return-tax',
  templateUrl: './manage-return-tax.component.html',
  styleUrls: ['./manage-return-tax.component.css']
})

export class ManageReturnTaxComponent implements OnInit {

  public download: string = "Download";
  checkBoxesMode: string;
  allMode: string;
  selectedItemKeys: any;
  mnge_rtn_tx_lst: any;
  userDtls: any;
  blob: Blob;
  fileName: any;

  constructor(private http: HttpClient,
    private usrService: UserService,
    private toaster: ToastrService,
    public router: Router) {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'onClick';
    // this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
    if (!localStorage.getItem('userDetails')) {
      // alert("User Already Loged out , Please Login Again");
      this.router.navigate(["login-admin"]);
    } else {
      this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
    }
  }

  ngOnInit() {
    this.getTaxes();
  }

  getTaxes() {
    this.usrService.manageReturnTax().subscribe((res) => {
      this.mnge_rtn_tx_lst = res['data'];
    })
  }

  selectionChanged(data: any) {
    this.selectedItemKeys = data.selectedRowKeys;
  }

  downloadFile(fileName: any) {
    console.log(fileName);
    let obj = {
      "userId": fileName.key.userId,
      "file_name": fileName.key.fileName
    }
    console.log(obj);
    let baseUrl = "https://9h6bwbaajf.execute-api.ap-south-1.amazonaws.com/dev/"; 
    // let baseUrl = "http://192.168.1.104:2528/";
    this.http.post(baseUrl + "retax_fileDownload", obj).subscribe((res: any) => {
      if (res.code === 200) {
        this.toaster.success(res.message);
      } else {
        this.toaster.error(res.message);
      }
    }, (err => console.error('er', err)));

    this.downloadExcelFile(fileName)
  }
  downloadExcelFile(data: any) {
    console.log(data.key.fileName);
    window.location.href = data.key.fileName;
  }
}
